import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    CardWrapper,
    SelectionCard,
    ModalHeading,
    ModalSubHeading,
    Note
} from "../Styles/InputStyles";
import { Select, MenuItem, FormControl } from "@mui/material";
import { toast } from "react-toastify";
import { MdOutlineInfo } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";

const TermsAgreement = ({ onClose, addTermLoading, addTermMutate, propId }) => {
    const initialValues = {
        perfectFit: "",
        securityDeposit: "",
        agreementPeriod: 11,
        noticePeriod: 1,
        lockInPeriod: 1,
    };

    const perfectFit = [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
        { value: 3, label: "Both" },
    ];

    const handleSubmit = (values) => {
        const securityDepositRegex = /^\d{1,6}$/;
        const maxSecurityDeposit = 1000000;

        if (
            !values.perfectFit ||
            !values.lockInPeriod ||
            !values.noticePeriod ||
            !values.agreementPeriod
        ) {
            toast.error("All Fields are required");
            return;
        }

        if (
            (values.securityDeposit &&
                !securityDepositRegex.test(values.securityDeposit)) ||
            parseInt(values.securityDeposit) > maxSecurityDeposit
        ) {
            toast.error(
                "Security deposit must be between 1 and 10,00,000 and contain only numbers"
            );
            return;
        }

        addTermMutate({
            tenantPreference: values.perfectFit,
            securityDeposit: Number(values.securityDeposit || 0),
            agreementPeriod: values.agreementPeriod,
            noticePeriod: values.noticePeriod,
            lockInPeriod: values.lockInPeriod,
            propId,
        });
    };

    const validationSchema = Yup.object({
        perfectFit: Yup.string().required("Please select Perfect Fit"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, setFieldValue, errors, touched }) => (
                <Form>
                    <ModalSubHeading>Step 2</ModalSubHeading>
                    <ModalHeading>Tenant & Agreement Details</ModalHeading>

                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label>A Perfect Fit For *</Label>
                                <CardWrapper>
                                    {perfectFit.map((mode) => (
                                        <SelectionCard
                                            key={mode.value}
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setFieldValue("perfectFit", mode.value);
                                            }}
                                            className={
                                                values.perfectFit === mode.value
                                                    ? "bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 text-white"
                                                    : "bg-gray-100 text-gray-800"
                                            }
                                        >
                                            <span className="text-sm">{mode.label}</span>
                                        </SelectionCard>
                                    ))}
                                </CardWrapper>
                                {touched.perfectFit && errors.perfectFit && (
                                <p className="text-rose-600 text-sm">
                                    {errors.perfectFit}
                                </p>
                                )}
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="securityDeposit">Security Deposit </Label>
                                <FieldWrappers>
                                    <Field
                                        type="number"
                                        name="securityDeposit"
                                        id="securityDeposit"
                                        autoComplete="off"
                                    />
                                </FieldWrappers>
                                <Note>
                                    <MdOutlineInfo className="mt-0.5 mr-1" />
                                    This amount can be changed later
                                </Note>
                            </InputGroup>


                            <InputGroup>
                                <Label htmlFor="agreementPeriod">Agreement Period *</Label>
                                <FormControl fullWidth>
                                    <Select
                                        className="px-2"
                                        id="agreementPeriod"
                                        name="agreementPeriod"
                                        value={values.agreementPeriod}
                                        onChange={(e) =>
                                            setFieldValue("agreementPeriod", e.target.value)
                                        }
                                        required
                                        style={{ height: "46px" }}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => i + 1).map(
                                            (month) => (
                                                <MenuItem key={month} value={month}>
                                                    {month} {month === 1 ? "Month" : "Months"}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                            </InputGroup>

                            {/* <CombineInputGroup> */}
                            <InputGroup>
                                <Label htmlFor="noticePeriod">Notice Period *</Label>
                                <FormControl fullWidth>
                                    <Select
                                        className="px-2"
                                        id="noticePeriod"
                                        name="noticePeriod"
                                        value={values.noticePeriod}
                                        onChange={(e) =>
                                            setFieldValue("noticePeriod", e.target.value)
                                        }
                                        required
                                        style={{ height: "46px" }}
                                    >
                                        {Array.from({ length: 6 }, (_, i) => i + 1).map((month) => (
                                            <MenuItem key={month} value={month}>
                                                {month} {month === 1 ? "Month" : "Months"}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="lockInPeriod">Lock-In Period *</Label>
                                <FormControl fullWidth>
                                    <Select
                                        className="px-2"
                                        id="lockInPeriod"
                                        name="lockInPeriod"
                                        value={values.lockInPeriod}
                                        onChange={(e) =>
                                            setFieldValue("lockInPeriod", e.target.value)
                                        }
                                        required
                                        style={{ height: "46px" }}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => i + 1).map(
                                            (month) => (
                                                <MenuItem key={month} value={month}>
                                                    {month} {month === 1 ? "Month" : "Months"}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                            </InputGroup>
                            {/* </CombineInputGroup> */}
                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={onClose}>
                            Cancel
                        </SideCancelBtn>
                        <SubmitBtn type="submit" disabled={addTermLoading}>
                            {addTermLoading ? "Processing..." : "Next"}
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};
// const Note = tw.p`text-xs text-gray-400 flex`;
export default TermsAgreement;
